import { request } from '@faire/web-api--source';
import { IGetCategoryMetaTagsRequest } from '@faire/web-api--source/indigofair/seo/IGetCategoryMetaTagsRequest';
import { IGetCategoryMetaTagsResponse } from '@faire/web-api--source/indigofair/seo/IGetCategoryMetaTagsResponse';
import { ALL_WEB_API_ENDPOINTS_TAG } from '@faire/web-api--source/next';
import {
  EndpointOptions,
  RequestOptions,
  SuccessResponse,
} from '@faire/web-api--source/types';

export const path = () => {
  return `/api/seo/category-meta-tags`;
};

export const build = (
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions
): RequestOptions & { route: string } => {
  const headers = options?.headers ?? new Headers();
  if (!headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  return {
    route,
    service,
    url: path(),
    method: 'POST',
    data,
    ...options,
    headers,
  };
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/seo/category-meta-tags';

/**
 * The service that handles this endpoint
 */
export const service = 'backend';

/**
 * Product Area: SEO
 */
function execute(
  data: IGetCategoryMetaTagsRequest
): Promise<IGetCategoryMetaTagsResponse>;
function execute(
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions & { rawResponse: true }
): Promise<SuccessResponse<IGetCategoryMetaTagsResponse>>;
function execute(
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions
): Promise<IGetCategoryMetaTagsResponse>;
function execute(
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions
): Promise<
  IGetCategoryMetaTagsResponse | SuccessResponse<IGetCategoryMetaTagsResponse>
> {
  const requestOptions = build(data, options);
  return request<IGetCategoryMetaTagsResponse>(requestOptions);
}
export default execute;

/**
 * Generated from the CacheControlHeader endpoint annotation.
 */
export const NEXT_CACHE_REVALIDATION_SECONDS = 7200;

/**
 * Execute the request, utilizing the Next.js data cache.
 * Unless specified otherwise, the request will be revalidated after 7200 second(s).
 * This function should only be used in a Next.js server environment.
 * @see execute
 */
export function executeWithNextCache(
  data: IGetCategoryMetaTagsRequest
): Promise<IGetCategoryMetaTagsResponse>;
export function executeWithNextCache(
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions & { rawResponse: true } & {
    next?: RequestOptions['next'];
  }
): Promise<SuccessResponse<IGetCategoryMetaTagsResponse>>;
export function executeWithNextCache(
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions & { next?: RequestOptions['next'] }
): Promise<IGetCategoryMetaTagsResponse>;
export function executeWithNextCache(
  data: IGetCategoryMetaTagsRequest,
  options?: EndpointOptions & { next?: RequestOptions['next'] }
): Promise<
  IGetCategoryMetaTagsResponse | SuccessResponse<IGetCategoryMetaTagsResponse>
> {
  const requestOptions = build(data, options);
  requestOptions.next ??= {};
  requestOptions.next.revalidate ??= NEXT_CACHE_REVALIDATION_SECONDS;
  requestOptions.next.tags ??= [];
  requestOptions.next.tags.push(ALL_WEB_API_ENDPOINTS_TAG);
  requestOptions.next.tags.push(route);
  return request<IGetCategoryMetaTagsResponse>(requestOptions);
}
